// extracted by mini-css-extract-plugin
export default {"overlay":"Ws-z","bodyOpen":"Xs-z","content":"Ys-z","header":"Zs-z","close":"_s-z","closeNoHeading":"at-z"};